module.exports = __webpack_public_path__ + "static/use-case-3-content-7-e09260464104ff978ff7a18b3186a31f.png";